import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { tokenverfy } from '../services/seller/api';
import { loggedIn } from '../store/slice/authSlice';
import { Spinner } from '@shopify/polaris';
import { clearHandoffToken, getCookieHandoffToken } from '../shared/handoff-token';

export default function AudienceRedirect() {
  const authUrl = process.env.REACT_APP_REDIRECT_URL;
  const nextRedirectUrl = process.env.REACT_APP_WEB_BASE_URL || window.location.origin; 
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true); // Centralized loading state

  useEffect(() => {
    const verifyAndNavigate = async () => {
      const localToken = localStorage.getItem('satellizer_token');
      const cookieToken = getCookieHandoffToken();
      const urlToken = cookieToken ?? urlParams.get('token');

      // The handoff script already stored cookieToken in localStorage, so it must not be gated on !localToken.
      if (urlToken && (cookieToken || !localToken)) {
        localStorage.setItem('satellizer_token', urlToken);
        clearHandoffToken();

        // Clean the URL by removing the token parameter
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);

        // Verify the token after saving it
        const data = { token: urlToken, validate_token_request: 1 };
        try {
          const response = await tokenverfy(data);
          if (response) {
            dispatch(
              loggedIn({
                userData: {
                  first_name: response.data.userData.first_name,
                  last_name: response.data.userData.last_name,
                  company_name: response.data.userData.company_name,
                  email: response.data.userData.email,
                },
                model: {
                  company_id: response.data.model.company_id,
                },
                result: response.data.result, // This already contains the array of accounts
                token: urlToken, // Use the stored token
              })
            );
            navigate('/shiprocket_audience');
            window.location.reload();
          } else {
            const redirectUrl = `${authUrl}/login?nextRedirectUrl=${nextRedirectUrl}/shiprocket_audience`;
            window.location.href = redirectUrl;
          }
        } catch (error) {
          console.error('Token verification failed:', error);
          const redirectUrl = `${authUrl}/login?nextRedirectUrl=${nextRedirectUrl}/shiprocket_audience`;
          window.location.href = redirectUrl;
        } finally {
          setLoading(false); // End loading after verification attempt
        }
      } else if (!localToken && !urlToken) {
        const redirectUrl = `${authUrl}/login?nextRedirectUrl=${nextRedirectUrl}/shiprocket_audience`;
        window.location.href = redirectUrl;
      } else {
        setLoading(false); // End loading if token is already present
      }
    };

    verifyAndNavigate(); // Call the async function inside useEffect
  }, [dispatch, navigate, urlParams, authUrl, nextRedirectUrl]);



  
  return <></>; // Empty div when loading is finished
}
